<template>
<v-card flat tile full-width >
    <v-overlay absolute
      :value="overlay" >
      <v-progress-circular indeterminate size=48 color='amber' /><br/>
      Saving
    </v-overlay>
    <v-progress-linear v-if='loading' indeterminate class='ma-0 pa-0' height="2" />
    <v-toolbar
      v-if='currentStep'
      dense flat extended >
      <v-btn @click='window--' icon :disabled='window === 0' ><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-toolbar-title >
        {{currentStep.title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class='mt-6' x-large outlined @click='$emit("close")' v-if='currentStep.withDone' >Done</v-btn>
      <!-- <v-progress-circular indeterminate color='amber' width='2' /> -->
      <v-btn @click='next' :disabled='window >= steps.length' icon >
        <v-icon>mdi-chevron-right</v-icon></v-btn>
      <p slot='extension' class='pl-14' v-text='currentStep.subtitle' ></p>
    </v-toolbar>
    <v-divider />
    <v-window vertical
      @keydown.40='next'
      v-model="window">
      <v-window-item
        v-for='(step, index) in steps'
        @keypress.enter.prevent='next'
        :key="step.id"
        :value='index' >
        <v-card full-width >
          <v-card-text>
            <component
              v-on='$listeners'
              :is='step.component'
              v-bind='step.attrs' />
          </v-card-text>
        </v-card>
      </v-window-item>
      <v-window-item v-if='withSuccessScreen' :key='steps.length' >
        <slot name='success' >
          <center>
            <v-card class='justify-center ma-4' width='300' >
              <v-card-title class='subtitle-1 overline text-center' >
                <v-spacer />
                Success
                <v-spacer />
              </v-card-title>
              <v-card-text class='text-center'>
                <v-icon size='42' color='success' >mdi-check-circle</v-icon>
              </v-card-text>
              <v-card-actions >
                <v-btn @click='$emit("reset")' text >{{resetText}}</v-btn>
                <v-spacer />
                <v-btn @click='$emit("close")' outline >{{doneText}}</v-btn>
              </v-card-actions>
            </v-card>
          </center>
        </slot>
      </v-window-item>
    </v-window>

    <v-footer >
      <v-btn
        @click='window--' icon :disabled='window === 0 || loading' >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if='!isValid' text
        @click='next' :disabled='window >= steps.length'  >
        Next <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn v-else
        @click="$emit('save', item)"
        :loading='loading'
        color='primary'
        v-text='callToActionText' />
    </v-footer>
</v-card>
</template>
<script>
export default {
  name: 'Wizard',
  props: {
    steps: { type: Array, required: true },
    step: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    isValid: { type: Boolean, default: false },
    withSuccessScreen: { type: Boolean, default: true },
    callToActionText: { type: String, default: 'Create' },
    resetText: { type: String, default: 'Add another' },
    doneText: { type: String, default: 'Done' }
  },
  data () {
    return {
      window: 0,
      item: {}
    }
  },
  mounted () {
    this.window = this.step
  },
  watch: {
    item () {
      this.$emit('input', this.item)
    },
    window () {
      this.$emit('update:step', this.window)
    },
    step () {
      this.window = this.step
    },
    gotosuccess () {
      this.step = 'success'
    }
  },
  computed: {
    currentStep () {
      return this.steps[this.window]
    }
  },
  methods: {
    next () {
      if (this.currentStep) {
        this.$emit('before:next:' + this.currentStep.id)
      }
      if (this.currentStep && this.currentStep.next) {
        return this.currentStep.next()
      }
      if (this.window <= this.steps.length) {
        this.window++
      }
    }
  }
}
</script>